import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {buildPath} from '@utils/util-builder';
import {ApiResponse} from '@models/api.response';
import {PaymentBlockRequest, PaymentBlockResponse} from '@models/payment-block.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentBlockService {
    private readonly _basePath: string = 'data-core/HotelCompany';

    constructor(private readonly _http: HttpClient) {
    }

    getPaymentBlock(hotelId: number, companyId: number): Observable<PaymentBlockResponse> {
        const params: HttpParams = new HttpParams()
            .set('hotelId', hotelId.toString())
            .set('companyId', companyId.toString());
        return this._http.get<ApiResponse<PaymentBlockResponse>>(
            buildPath([this._basePath, 'payment-block']), {params}
        ).pipe(map((response: ApiResponse<PaymentBlockResponse>): PaymentBlockResponse => response.data));
    }

    updatePaymentBlock(hotelId: number, companyId: number, paymentBlocked: boolean, reason: string | null): Observable<PaymentBlockResponse> {
        const body: PaymentBlockRequest = {
            hotelId,
            companyId,
            paymentBlocked,
            reason: paymentBlocked ? reason : null
        };
        return this._http.patch<ApiResponse<PaymentBlockResponse>>(
            buildPath([this._basePath, 'payment-block']), body
        ).pipe(map((response: ApiResponse<PaymentBlockResponse>): PaymentBlockResponse => response.data));
    }
}
